import { gql } from 'graphql-request';

export const BUDGET_REQUEST_FIELDS = gql`
  fragment BudgetRequestFields on BudgetRequestDto {
    budgetRequestId
    rowStatus
    taskId
    description
    requestedStartDate
    requestedEndDate
    maxBudgetAmount
    status
    originatorOrganizationId
    createdBy
    createdAt
    task {
      taskId
      name
      projectId
      project {
        address
        projectId
        name
      }
    }
    originatorOrganization {
      organizationId
      name
    }
    createdByUser {
      userId
      firstName
      lastName
      avatar
    }
    recipients {
      budgetRequestId
      recipientOrganizationId
      status
      respondedAt
      recipientOrganization {
        organizationId
        name
      }
    }
    proposals {
      budgetProposalId
      proposingOrganizationId
      description
      proposedStartDate
      proposedEndDate
      proposedAmount
      status
      isCounterProposal
      parentProposalId
      createdBy
      createdAt
      proposingOrganization {
        organizationId
        name
      }
      createdByUser {
        userId
        firstName
        lastName
        avatar
      }
    }
    documents {
      documentId
      name
      url
      category
    }
    delegateTaskId
    delegationCancelledAt
  }
`;

export const BUDGET_PROPOSAL_FIELDS = gql`
  fragment BudgetProposalFields on BudgetProposalDto {
    budgetProposalId
    budgetRequestId
    proposingOrganizationId
    description
    proposedStartDate
    proposedEndDate
    proposedAmount
    status
    isCounterProposal
    parentProposalId
    createdBy
    createdAt
    proposingOrganization {
      organizationId
      name
    }
    createdByUser {
      userId
      firstName
      lastName
      avatar
    }
    budgetRequest {
      budgetRequestId
      taskId
      description
      requestedStartDate
      requestedEndDate
      maxBudgetAmount
      status
      task {
        taskId
        name
        projectId
        project {
          projectId
          name
        }
      }
    }
    documents {
      documentId
      name
      url
      category
    }
  }
`;

export const getPendingBudgetRequests = gql`
  query getPendingBudgetRequests {
    pendingBudgetRequests {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const getBudgetRequestDetails = gql`
  query getBudgetRequestDetails($budgetRequestId: String!) {
    budgetRequestDetails(budgetRequestId: $budgetRequestId) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const getBudgetProposalConversation = gql`
  query getBudgetProposalConversation($budgetRequestId: String!) {
    budgetProposalConversation(budgetRequestId: $budgetRequestId) {
      ...BudgetProposalFields
    }
  }
  ${BUDGET_PROPOSAL_FIELDS}
`;

export const getBudgetRequestsByTaskId = gql`
  query getBudgetRequestsByTaskId($taskId: String!) {
    budgetRequestsByTaskId(taskId: $taskId) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const paginatedBudgetRequestsByOrganization = gql`
  query PaginatedBudgetRequestsByOrganization(
    $input: GetPaginatedBudgetRequestsInput!
  ) {
    paginatedBudgetRequestsByOrganization(input: $input) {
      count
      totalBeforeStatusFilter
      actionableCount
      facets {
        status
        count
      }
      budgetRequests {
        ...BudgetRequestFields
      }
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

// Mutations
export const createBudgetRequest = gql`
  mutation createBudgetRequest($input: BudgetRequestCreateInput!) {
    createBudgetRequest(input: $input) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const respondToBudgetRequest = gql`
  mutation respondToBudgetRequest($input: BudgetProposalCreateInput!) {
    respondToBudgetRequest(input: $input) {
      ...BudgetProposalFields
    }
  }
  ${BUDGET_PROPOSAL_FIELDS}
`;

export const createCounterProposal = gql`
  mutation createCounterProposal($input: BudgetCounterProposalCreateInput!) {
    createCounterProposal(input: $input) {
      ...BudgetProposalFields
    }
  }
  ${BUDGET_PROPOSAL_FIELDS}
`;

export const acceptBudgetProposal = gql`
  mutation acceptBudgetProposal($proposalId: String!) {
    acceptBudgetProposal(proposalId: $proposalId) {
      ...BudgetProposalFields
    }
  }
  ${BUDGET_PROPOSAL_FIELDS}
`;

export const rejectBudgetProposal = gql`
  mutation rejectBudgetProposal($proposalId: String!) {
    rejectBudgetProposal(proposalId: $proposalId) {
      ...BudgetProposalFields
    }
  }
  ${BUDGET_PROPOSAL_FIELDS}
`;

export const acceptBudgetRequest = gql`
  mutation acceptBudgetRequest($budgetRequestId: String!) {
    acceptBudgetRequest(budgetRequestId: $budgetRequestId) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const rejectBudgetRequest = gql`
  mutation rejectBudgetRequest($budgetRequestId: String!) {
    rejectBudgetRequest(budgetRequestId: $budgetRequestId) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

export const cancelBudgetRequest = gql`
  mutation cancelBudgetRequest($budgetRequestId: String!) {
    cancelBudgetRequest(budgetRequestId: $budgetRequestId) {
      ...BudgetRequestFields
    }
  }
  ${BUDGET_REQUEST_FIELDS}
`;

const BudgetsGraphQL = {
  queries: {
    getPendingBudgetRequests,
    getBudgetRequestDetails,
    getBudgetProposalConversation,
    getBudgetRequestsByTaskId,
    paginatedBudgetRequestsByOrganization,
  },
  mutations: {
    createBudgetRequest,
    respondToBudgetRequest,
    createCounterProposal,
    acceptBudgetProposal,
    rejectBudgetProposal,
    acceptBudgetRequest,
    rejectBudgetRequest,
    cancelBudgetRequest,
  },
};

export default BudgetsGraphQL;
